import 'slick-carousel'
import GET_ARTICLES from '../plugins/getArticles';

export default function HOME() {

  $(() => {
  
    // トップページカスタム
    $.topInit();
  
    // ブロック整形
    (function(__){ $.each(__, $.topBlockCustomizer) }({
      'news':{
        button:{
          disp: true,
          text: 'VIEW ALL',
          attr: {
            class: 'button p-newsBlock__btn'
          }
        },
        title:{
          html: false // プレーンテキストで動的にする場合は false
        },
        itemlayout: function($this,$catetitle,$date,$new,$title,$catch,$body){
          $this
            .append( $date )
            .append( $catetitle.find('a').addClass('catetitle').text( $catetitle.text().replace(/^(.*)$/,'［$1］') ) )
            .append( $title.append($new) )
            // .append( $catch )
            // .append( $body )
          // $date.insertAfter( $catetitle );
        }
      }
    }));
  
    window.load['mainvisual'].done(() => {

      /*****
       * Slick実行
       */
      $('[data-plugin="slider"]').slick({
        autoplay:true,
        fade: true,
        dots: false,
        speed: 1200,
        autoplaySpeed: 4000,
        pauseOnHover: false,
        pauseOnFocus: false,
        arrows: false
      })

    })


    $.when(
      window.load['block-process']
    ).done(()=>{
      GET_ARTICLES('.p-block-process [data-plugin="getArticles"]').done(() => {
        $('.p-block-process__list').slick({
          autoplay: true,
          fade: false,
          speed: 200,
          pauseOnHover: false,
          pauseOnFocus: false,
          centerMode: true,
          arrows: false,
          infinite: true,
          variableWidth: true,
          swipeToSlide:true,
          slidesToShow: 4,
          responsive: [{
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
            }
          }]
        })
      })
    })
  
  });
}